<template>
    <div class="kanban-toolbar">
        <KanbanSummary
            :records="records"
            :selectedField="currentField"
            :kanbanField="kanbanField"
        />

        <div class="toolbar-actions">
            <CustomPicker
                class="kanban-field-selector"
                v-model="currentField"
                :items="fields"
                idKey="_id"
                labelKey="name"
                title="Select a field"
                icon="view_week"
                @input="handleFieldChange"
            />
            <SupsisButton type="primary" @click="$emit('open-settings')" ghost>
                <i class="material-icons">settings</i>
                <span>{{ $t("modules.kanbanSettings.kanban")}}</span>
            </SupsisButton>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import CustomPicker from "@/components/pickers/CustomPicker.vue";
import SupsisButton from "@/views/Pages/Settings/components/SupsisButton.vue";
import KanbanSummary from "./KanbanSummary.vue";

export default Vue.extend({
    name: "KanbanToolbar",
    components: {
        CustomPicker,
        SupsisButton,
        KanbanSummary,
    },
    props: {
        fields: {
            type: Array,
            default: function() {
                return [];
            },
        },
        selectedField: {
            type: String,
            default: null,
        },
        records: {
            type: Array,
            default: function() {
                return [];
            },
        },
        kanbanField: {
            type: Object,
            default: null,
        }
    },
    data: function() {
        return {
            currentField: this.selectedField,
        };
    },
    watch: {
        selectedField: function(newVal) {
            this.currentField = newVal;
        },
    },
    methods: {
        handleFieldChange: function(newValue) {
            this.$emit("change-field", newValue);
        },
    },
});
</script>

<style scoped lang="scss">
.kanban-toolbar {
    display: flex;
    align-items: center;
    padding: 10px 0;
    justify-content: flex-end;
    gap:5px;

    .toolbar-actions {
        display: flex;
        align-items: center;
        gap: 16px;

        .kanban-field-selector {
            min-width: 150px;
        }
    }
}
</style>
